<script>
export default {
    name: "ButtonMobilePrev"
}
</script>
<template>
    <svg id="Group_1477" data-name="Group 1477" xmlns="http://www.w3.org/2000/svg" width="78.827" height="40.102" viewBox="0 0 78.827 40.102">
        <g id="Group_938" data-name="Group 938" transform="translate(40.102 40.102) rotate(180)">
            <path id="Path_1070" data-name="Path 1070" d="M0,16.663,16.663,0,33.327,16.663" transform="translate(25.613 3.506) rotate(90)" fill="none" stroke="#000" stroke-width="1"/>
            <g id="Ellipse_48" data-name="Ellipse 48" transform="translate(0 0)" fill="none" stroke="#000" stroke-width="1">
                <ellipse cx="20.051" cy="20.051" rx="20.051" ry="20.051" stroke="none"/>
                <ellipse cx="20.051" cy="20.051" rx="19.551" ry="19.551" fill="none"/>
            </g>
        </g>
        <text id="prev" transform="translate(54.827 21.863)" font-size="10" font-family="Apertura-Medium, Apertura" font-weight="500" letter-spacing="0.1em"><tspan x="0" y="0">prev</tspan></text>
    </svg>
</template>